// extracted by mini-css-extract-plugin
export default {"option":"TickerDropdown_option__aCGaf","svg":"TickerDropdown_svg__XP5dg"};